import React from "react";
import Accordion from "../components/Accordion";
import Navbar from "../components/Navbar";
import { ApplyCodes } from "../components/ApplyCodes";
import { useState, useEffect } from "react";
import "./PatientPageStyle.css";
import TextFieldComp from "../components/TextFieldComp";
import axios from "axios";

const PatientPage = () => {
  const [encounter, setEncounter] = useState();

  // TODO: use user data for something so CI doesn't complain (CI currently complains about this)
  // const [user, setUser] = useState({});
  // useContext(BackendContext).userInfo().then(setUser).catch(console.log);

  //   useEffect(() => {
  //     console.log("user = ", user);
  //   }, [user]);
  const PORT =
    "http://SkeleChaingang-env.eba-i65amzvv.us-west-2.elasticbeanstalk.com";
  // const PORT = 'http://femr-central-api.us-west-2.elasticbeanstalk.com/';

  useEffect(() => {
    const fetchEncounter = async () => {
      try {
        // currently hard code to be user_id = 556
        // TODO: need to update it to take user_id once the login is working
        const response = await axios.get(`${PORT}test_encounter/556/`);
        // console.log(response.data)
        setEncounter(response.data);
      } catch (error) {
        console.warn(error);
        return false;
      }
    };

    fetchEncounter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* TO DO: Add functionality to Submit button */
  if (!encounter) {
    return (
      <div className="PatientPage">
        <Navbar />
        <h3> &nbsp; Encounter loading ...</h3>
      </div>
    );
  }

  /* Note: History of Medical Codes is now dynamic as well. */

  /* This is a helper function that displays the contents of problems, narratives,
  physical exams, and assessments to be dynamic, and depends on the number 
  of fields specified by the encounter data.
  It takes in the specified encounter data title, field prefix of JSON,
  the field labels of the JSON, and the total number of fields of this encounter. */

  function generateAccordionContent(data, fieldPrefix, fieldLabel, numFields) {
    const accordionContent = [];

    for (let i = 1; i <= numFields; i++) {
      const fieldKey = `${fieldPrefix}${i}`;
      const fieldValue = data[i - 1]?.[fieldPrefix];

      if (fieldValue) {
        const fieldComponent = (
          <React.Fragment key={fieldKey}>
            <br />
            <TextFieldComp
              fieldLabel={`${fieldLabel} ${i}`}
              defaultValue_={fieldValue}
            />
            <br />
          </React.Fragment>
        );
        accordionContent.push(fieldComponent);
      }
    }

    return accordionContent;
  }

  const assessmentFields = generateAccordionContent(
    encounter["assessments"],
    "assessment",
    "Assessment",
    4
  );
  const physicalExamFields = generateAccordionContent(
    encounter["physical_examinations"],
    "physical_examination",
    "Physical Examination",
    4
  );
  const problemFields = generateAccordionContent(
    encounter["problems"],
    "problem",
    "Problem",
    9
  );
  const narrativeFields = generateAccordionContent(
    encounter["narratives"],
    "narrative",
    "Narrative",
    4
  );

  return (
    <div className="PatientPage">
      <Navbar />

      <div className="split_container">
        <div>
          <div className="align">
            <div>Patient ID: {encounter["patient"]}</div>
            <div>Visit Day: {encounter["date_of_triage_visit"]}</div>
          </div>
          <div className="align2">
            <div>Coder 1: {encounter["Coder_1"]}</div>
            <div>Coder 2: {encounter["Coder_2"]}</div>
          </div>
          <ApplyCodes />
        </div>

        <div className="patient_info">
          <Accordion
            title="History of Medical Codes"
            children={
              <div className="history_codes">
                {encounter["codes_"].map((code, index) => (
                  <div key={index}>
                    <br />
                    <div>
                      Submission Date: {code["arbiter_submission_date"]}
                    </div>
                    <br />
                    <div>
                      Office Visit Code:{" "}
                      {code["arbiter_office_visit_code"] &&
                        (Array.isArray(
                          code["arbiter_office_visit_code"]["codes"]
                        )
                          ? code["arbiter_office_visit_code"]["codes"].join(
                              ", "
                            )
                          : code["arbiter_office_visit_code"]["codes"])}
                    </div>
                    <br />
                    <div>
                      Problem Codes:{" "}
                      {code["arbiter_problem_code"] &&
                        (Array.isArray(code["arbiter_problem_code"]["codes"])
                          ? code["arbiter_problem_code"]["codes"].join(", ")
                          : code["arbiter_problem_code"]["codes"])}
                    </div>
                    <br />
                    <div>
                      Chief Complaint Codes:{" "}
                      {code["arbiter_chief_complaint_code"] &&
                        (Array.isArray(
                          code["arbiter_chief_complaint_code"]["codes"]
                        )
                          ? code["arbiter_chief_complaint_code"]["codes"].join(
                              ", "
                            )
                          : code["arbiter_chief_complaint_code"]["codes"])}
                    </div>
                    <br />
                    <div>
                      Covid Code:{" "}
                      {code["arbiter_covid19_code"] &&
                        (Array.isArray(code["arbiter_covid19_code"]["codes"])
                          ? code["arbiter_covid19_code"]["codes"].join(", ")
                          : code["arbiter_covid19_code"]["codes"])}
                    </div>
                    <hr />
                  </div>
                ))}
              </div>
            }
          />

          <Accordion
            title="Chief Complaint"
            children={
              /*TODO: dereference foreign keys*/
              <div>
                <br />
                <TextFieldComp defaultValue_={encounter["chief_complaint"]} />
                <br />
              </div>
            }
          />

          <Accordion
            title="Diagnosis"
            children={
              /*DNE in encounter*/
              <div>
                <br />
                <TextFieldComp defaultValue_={encounter["diagnosis"]} />
                <br />
              </div>
            }
          />

          <Accordion
            title="Patient Details"
            children={
              <div>
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Age"}
                  defaultValue_={encounter["age"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Gender"}
                  defaultValue_={encounter["gender"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Height (cm)"}
                  defaultValue_={encounter["height"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Weight (lbs)"}
                  defaultValue_={encounter["weight"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Week's Pregnant"}
                  defaultValue_={encounter["weeks_pregnant"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Alcohol Use"}
                  defaultValue_={encounter["alcohol_use"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"History of Diabetes"}
                  defaultValue_={encounter["history_of_diabetes"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Family History"}
                  defaultValue_={encounter["family_history"]}
                />{" "}
                <br />
              </div>
            }
          />

          <Accordion
            title="Patient Vitals"
            children={
              <div>
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Systolic Blood Pressure (mmHg)"}
                  defaultValue_={
                    encounter["patient_vitals"]["systolic_blood_pressure"]
                  }
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Diastolic Blood Pressure (diastolic)"}
                  defaultValue_={
                    encounter["patient_vitals"]["diastolic_blood_pressure"]
                  }
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Heart Rate (beats/minute)"}
                  defaultValue_={encounter["patient_vitals"]["heart_rate"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Mean Arterial Pressure (mmHg)"}
                  defaultValue_={
                    encounter["patient_vitals"]["mean_arterial_pressure"]
                  }
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Glucose Level (mg/dl)"}
                  defaultValue_={encounter["patient_vitals"]["glucose_level"]}
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Oxygen Concentration (percent)"}
                  defaultValue_={
                    encounter["patient_vitals"]["oxygen_concentration"]
                  }
                />{" "}
                <br />
                <br />
                <br />{" "}
                <TextFieldComp
                  fieldLabel={"Respiratory Rate (breaths/minute)"}
                  defaultValue_={
                    encounter["patient_vitals"]["respiratory_rate"]
                  }
                />{" "}
                <br />
              </div>
            }
          />

          <Accordion
            title="Assessments"
            children={<div className="assessments">{assessmentFields}</div>}
          />

          <Accordion
            title="Physical Examinations"
            children={
              <div className="physical_exams">{physicalExamFields}</div>
            }
          />

          <Accordion
            title="Problems"
            children={<div className="problems">{problemFields}</div>}
          />

          <Accordion
            title="Narratives"
            children={<div className="narratives">{narrativeFields}</div>}
          />

          <Accordion
            title="Current Medications"
            children={
              /*DNE in encounter*/
              <div>
                <br />{" "}
                <TextFieldComp
                  defaultValue_={encounter["current_medications"]}
                />{" "}
                <br />
              </div>
            }
          />

          <Accordion
            title="Dispense Medications"
            children={
              /*DNE in encounter*/
              <div>
                <br />{" "}
                <TextFieldComp
                  defaultValue_={encounter["dispense_medications"]}
                />{" "}
                <br />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PatientPage;
